function initPhoenixTestimonials() {
	let testimonialSlider = jQuery(this).slick({
		mobileFirst: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		dots: true,
	});
}

export {
	initPhoenixTestimonials
};
